import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'src/components/system/Button';
import { Page, Card, Title, Input, ErrorText } from './styles';
import { forgotPassword } from 'src/services/auth';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');
    try {
      const res = await forgotPassword(email);
      setMessage(
        res.status || 'Enviamos um link com instruções para redefinir sua senha. Verifique sua caixa de entrada.'
      );
    } catch (err: any) {
      setError('Não foi possível enviar o email.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Page>
      <Card>
        <Title>Esqueci minha senha</Title>
        <form onSubmit={onSubmit}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Input placeholder="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            {message && <div>{message}</div>}
            {error && <ErrorText>{error}</ErrorText>}
            <Button
              width="100%"
              backgroundColor="#222B82"
              borderColor="#222B82"
              buttonColor="#fff"
              type="submit"
              disabled={loading}
              label={<span>{loading ? 'Enviando...' : 'Enviar'}</span>}
            />
          </div>
        </form>
        <Link to="/auth/login">Voltar para login</Link>
      </Card>
    </Page>
  );
}
